// extracted by mini-css-extract-plugin
export default {"container":"EmailTab_container__BcZWP","info-box":"EmailTab_info-box__evCKQ"};